module.exports = __webpack_public_path__ + "static/media/40.1b23dc56.jpg";